import {Injectable} from '@angular/core';
import {ServerService} from '../services/server.service';
import {UserProfile} from './UserProfile';
import {DataService} from "../services/data.service";


export class UserData{
   public id?:number;
   public first_name?:string;
   public last_name?:string;
   public display_name?:string;
   public username?:string;
   public password?:string;
   public email?:string;
   public last_login?:string;
   public profile?:UserProfile;
   public date_joined?:string;
   public is_active?:boolean;
   public is_superuser?:boolean;
   public is_staff?:boolean;
}


@Injectable({
   providedIn: 'root'
})
export class UserFactory {

   public BASE_URL = "/api/utenti"

   constructor(private serverSrv:ServerService,
               private dataSrv: DataService) {

   }


   async getInfo():Promise<User> {
      return new Promise((resolve, reject) => {
         this.serverSrv.get(User,"/auth/info").then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async getUser(userID:number):Promise<User> {
      return new Promise((resolve, reject) => {
         this.serverSrv.get(User,`/api/utenti/${userID}`).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async deleteUser(userID:number):Promise<any> {
      return new Promise((resolve, reject) => {
         this.serverSrv.delete(`/api/utenti/${userID}`).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async getDashboardData():Promise<any> {
      return new Promise((resolve, reject) => {
         this.serverSrv.get(null,"/api/dashboard").then(res=>{
            this.dataSrv.dashboardData = res;
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async setPassword(user_id, password: any, esercizio_slug=null):Promise<any> {
      return new Promise((resolve, reject) => {
         let url = esercizio_slug ? `/api/esercizi/${esercizio_slug}/utenti/${user_id}/setpsw` : `${this.BASE_URL}/${user_id}/setpsw`
         this.serverSrv.post(url, {password}).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   getURLEserciziUtente(user_id){
      return `${this.BASE_URL}/${user_id}/esercizi_utente`
   }

   // esercizio utente

   async updateEsercizioUtente(user_id: any, key: any, values: any) {
      return new Promise((resolve, reject) => {
         this.serverSrv.put(`${this.BASE_URL}/${user_id}/esercizi_utente/${key}`, values)
            .then(res=>{
               resolve(res)
            })
            .catch(err=>{
               reject(err)
            })
      })
   }

   async addEsercizioUtente(user_id: any, data: any) {
      return new Promise((resolve, reject) => {
         this.serverSrv.post(`${this.BASE_URL}/${user_id}/esercizi_utente`, data)
            .then(res=>{
               resolve(res)
            })
            .catch(err=>{
               reject(err)
            })
      })
   }

   async deleteEsercizioUtente(user_id: any, ese_id) {
      return new Promise((resolve, reject) => {
         this.serverSrv.delete(`${this.BASE_URL}/${user_id}/esercizi_utente/${ese_id}`)
            .then(res=>{
               resolve(res)
            })
            .catch(err=>{
               reject(err)
            })
      })
   }

   // Punti vendita

   getPVenditaUtenteURL(user_id, esercizio_utente_id){
      return `${this.BASE_URL}/${user_id}/esercizi_utente/${esercizio_utente_id}/pvendita_utenti`
   }

   async addPVenditaUtente(user_id: any, esercizio_utente_id, data: any): Promise<any> {
      data["user"] = user_id
      return new Promise((resolve, reject) => {
         this.serverSrv.post(`${this.BASE_URL}/${user_id}/esercizi_utente/${esercizio_utente_id}/pvendita_utenti`, data)
            .then(res=>{
               resolve(res)
            })
            .catch(err=>{
               reject(err)
            })
      })
   }

   async editPVenditaUtente(user_id: any, esercizio_utente_id, pvendita_id, data: any): Promise<any> {
      data["user"] = user_id
      return new Promise((resolve, reject) => {
         this.serverSrv.put(`${this.BASE_URL}/${user_id}/esercizi_utente/${esercizio_utente_id}/pvendita_utenti/${pvendita_id}`, data)
            .then(res=>{
               resolve(res)
            })
            .catch(err=>{
               reject(err)
            })
      })
   }

   async removePVenditaUtente(user_id: any, esercizio_utente_id, pvendita_id): Promise<any> {
      return new Promise((resolve, reject) => {
         this.serverSrv.delete(`${this.BASE_URL}/${user_id}/esercizi_utente/${esercizio_utente_id}/pvendita_utenti/${pvendita_id}`)
            .then(res=>{resolve(res)})
            .catch(err=>{reject(err)})
      })
   }
}


export class User {

   public data: UserData = {
      is_superuser: false
   }

   ID?: number;
   IsStaff:any = false;
   IsAdmin:any = false;

   constructor(data:UserData = {}) {
      if(!data) data = {}
      Object.assign(this.data, data);

      if (this.data.id != null) {
         this.ID = data.id;
      }

      if(!data.profile)
         this.data.profile = new UserProfile();
      else
         this.data.profile = new UserProfile(data.profile);

      this.IsStaff = this.data.is_staff;
      this.IsAdmin = this.data.is_superuser || this.data.is_staff;
   }

   public static isAdmin(data: any){
      let u = new User(data)
      return u.IsAdmin
   }

   get DisplayName(){
      if(this.data.first_name && this.data.last_name){
         return `${this.data.username} (${[this.data.first_name, this.data.last_name].join(" ")})`
      }
      return this.data.username;
   }



}
